import type { ReactNode } from 'react'
import { ChevronLeft } from 'lucide-react'
import { TabBar, type Tab } from './TabBar'
import { BuildFooter } from './BuildInfo'

export interface SubScreenNav {
  title: string
  onBack: () => void
  action?: ReactNode
}

export interface AppShellProps {
  children: ReactNode
  // Tab mode
  tab?: Tab
  onTab?: (tab: Tab) => void
  onHistory?: () => void
  onNewChat?: () => void
  onSettings?: () => void
  /** Per-tab toolbar override (e.g. "+ Neu" on Prompts/Dokumente). */
  tabActions?: ReactNode
  // Sub-screen mode (back chevron + title, no tabs)
  back?: SubScreenNav
}

export function AppShell({
  children,
  tab,
  onTab,
  onHistory,
  onNewChat,
  onSettings,
  tabActions,
  back,
}: AppShellProps) {
  return (
    <div className="flex h-full w-full flex-col bg-white font-sans text-neutral-900">
      {back ? (
        <div className="flex items-center gap-2 border-b border-neutral-200 px-3 py-3">
          <button
            type="button"
            onClick={back.onBack}
            aria-label="Zurück"
            className="flex h-8 w-8 items-center justify-center rounded-lg text-neutral-600 hover:bg-neutral-100"
          >
            <ChevronLeft className="h-5 w-5" />
          </button>
          <h1 className="text-lg font-bold">{back.title}</h1>
          {back.action && <div className="ml-auto">{back.action}</div>}
        </div>
      ) : tab && onTab ? (
        <TabBar
          tab={tab}
          onTab={onTab}
          onHistory={onHistory}
          onNewChat={onNewChat}
          onSettings={onSettings}
          actions={tabActions}
        />
      ) : null}
      <main className="relative flex min-h-0 flex-1 flex-col">{children}</main>
      <BuildFooter />
    </div>
  )
}
